import { type FC, useState } from "react";

import { Modal } from "@alpacahq/ui/old";

import { useMutationRequest } from "~/v2/api/hooks";
import type { Account } from "~/v2/api/rest/account";
import {
  type AlgoRoutingModel,
  applyEliteAlgoRouting,
} from "~/v2/api/rest/elite";
import { CommissionModelTable } from "./CommissionModelTable";
import { CommissionModelUpdated } from "./CommissionModelUpdated";

type CommissionModelModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  model?: AlgoRoutingModel;
  account: Account;
};

export const CommissionModelModal: FC<CommissionModelModalProps> = ({
  isOpen,
  setIsOpen,
  model,
  account,
}) => {
  const [isUpdated, setIsUpdated] = useState(false);

  const mutation = useMutationRequest(
    (model: AlgoRoutingModel) => applyEliteAlgoRouting(account.id, model),
    {
      onSuccess: () => {
        setIsUpdated(true);
      },
    },
  );

  const onSelectedCommissionModel = (model: AlgoRoutingModel) => {
    mutation.mutate(model);
  };

  return (
    <Modal
      isOpen={isOpen}
      size="xl"
      onClose={() => {
        setIsOpen(false);
        setIsUpdated(false);
      }}
      title={
        isUpdated ? (
          <span className="block text-center">Thank you!</span>
        ) : (
          "Select the commission model for stocks trading:"
        )
      }
    >
      {isUpdated ? (
        <CommissionModelUpdated onClose={() => setIsOpen(false)} />
      ) : (
        <CommissionModelTable
          currentModel={model}
          onSelectCommissionModel={onSelectedCommissionModel}
        />
      )}
    </Modal>
  );
};
